import { AxiosRequestConfig, AxiosResponse } from "axios";
import buildFullPath from "axios/lib/core/buildFullPath";
import buildURL from "axios/lib/helpers/buildURL";
import url from "url";
import qs from "qs";
import cloud from "@qn/services/cloud";
import cleanQnToken from "../api/cleanQnToken";
import authorize from "../api/authorize";

const sessionExpiredMessage = "您好，您没有可访问的店铺！";

let authPromise: Promise<void> | undefined;

async function reAuthorize() {
    if (authPromise) {
        return authPromise;
    }

    const promise = async () => {
        await cleanQnToken();

        await authorize();
    };

    authPromise = promise();

    try {
        await authPromise;
    } finally {
        authPromise = undefined;
    }
}

function paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: "repeat" });
}

function getNodeHeader(host) {
    switch (host) {
        case "tb.fahuoyi.com":
            return "tb";
        case "pdd.fahuoyi.com":
            return "pdd";
        case "other.fahuoyi.com":
            return "other";
        case "ali.fahuoyi.com":
            return "ali";
        case "jd.fahuoyi.com":
            return "jd";
        case "main.fahuoyi.com":
            return "main";
        case "dyali.fahuoyi.com":
            return "dy";
        case "dy.fahuoyi.com":
            return "doudian";
        default:
            return "";
    }
}

/**
 * 千牛http的axios适配器，需要走cloud.application.httpRequest api 请求到后端
 */
const tbPCAxiosAdapter = async function (config: AxiosRequestConfig, fromCommonApi = true): Promise<AxiosResponse> {
    try {
        const httpMethod = config.method.toUpperCase();

        const fullPath = buildFullPath(config.baseURL, config.url);

        const requestUrl = buildURL(fullPath, config.params, paramsSerializer);

        const requestBody = config.data;

        const urlParsed = url.parse(requestUrl, true);

        const path = urlParsed.pathname;

        const params = urlParsed.query;

        const node = getNodeHeader(urlParsed.host);

        const data = await cloud.application.httpRequest({
            path: path,
            method: httpMethod,
            body: requestBody,
            params: params,
            headers: {
                node,
            },
            exts: {
                timeout: 10000,
            },
        });

        console.log(node, path, params, requestBody, data);

        const headers = {};

        let trueData = {
            code: 0,
            data: data,
        };

        // 适配拼多多解密
        if (requestUrl.includes("/pdd/control/decrypt/v1/address")) {
            trueData = data;
        }

        const response: AxiosResponse = {
            data: trueData,
            status: 200,
            statusText: "OK",
            config: config,
            headers: headers,
        };

        return response;
    } catch (error) {
        console.error(error);
        console.log(error && error.code);
        console.log(error && error.message);

        const code = Number((error && error.code) || 500);
        let message = (error && error.message) || "发生未知错误";

        // 此处使用正则解析，错误信息, 错误信息样式如 "503:::错误信息"
        message = message.replace(/^(.+?):::/, "");

        // 如果有提示信息，且包含sessionExpiredMessage，说明是session过期，需要重新授权
        if (typeof message === "string" && message.includes(sessionExpiredMessage) && fromCommonApi) {
            await reAuthorize();

            return tbPCAxiosAdapter(config, false);
        }

        if (code === 501) {
            let data501 = {};

            try {
                data501 = JSON.parse(message);
            } catch (error) {}

            const response: AxiosResponse = {
                data: {
                    code: code,
                    data: data501,
                },
                status: code,
                statusText: `${code}`,
                config: config,
                headers: {},
            };

            return response;
        }

        const response: AxiosResponse = {
            data: {
                code: code,
                message: message,
            },
            status: code,
            statusText: `${code}`,
            config: config,
            headers: {},
        };

        return response;
    }
};

export default tbPCAxiosAdapter;
